
const BASE_URL = ENV_DEV ? "http://user.t.quanmaikeji.com" : "https://user.quanmaikeji.com";
const HWEB_URL = ENV_DEV ? "http://h5.t.quanmaikeji.com" : "https://h5.quanmaikeji.com";
const SHOP_URL = ENV_DEV ? "http://shop.t.quanmaikeji.com" : "https://shop.quanmaikeji.com";
export default {
    BASE_URL,
    HWEB_URL,
    SHOP_URL
}
//token 临时票据


// WEBPACK FOOTER //
// ./src/service/params.js